var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapeBottomRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519 384"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-bottom-right_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27559",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h519v384H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-bottom-right_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27558",
    stroke: "#707070",
    fill: "url(#shape-bottom-right_svg__a)",
    d: "M0 0h1060v664H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "shape-bottom-right_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 27557",
    fill: "url(#shape-bottom-right_svg__a)",
    d: "M0 0h1245v1131H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shape-bottom-right_svg__a",
    x1: 0.5,
    y1: 1,
    x2: 0.504,
    y2: 0.687,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "currentColor",
    stopOpacity: 0.322
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 703",
    clipPath: "url(#shape-bottom-right_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 702",
    transform: "translate(-190 -280)",
    opacity: 0.5,
    clipPath: "url(#shape-bottom-right_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40552"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40551",
    clipPath: "url(#shape-bottom-right_svg__d)",
    transform: "translate(-475 -467)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17660",
    d: "M242.917 1038.243s53.794 93.216 161.378 93.216h438.016s107.589 0 161.378-93.216L1222.7 658.871s53.794-93.167 0-186.333L1003.689 93.167S949.9 0 842.311 0H404.295S296.711 0 242.917 93.167L23.909 472.538s-53.794 93.167 0 186.333z",
    transform: "translate(-.25 .271)",
    fill: "url(#shape-bottom-right_svg__a)"
  })))))));
}
export default SvgShapeBottomRight;